import {
  IonButton,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel
} from '@ionic/react'
import { createOutline } from 'ionicons/icons'
import moment from 'moment'
import React from 'react'
import { Person } from '../form/person.card'

interface Props {
  onEdit?: () => any
  additional: {
    pool: boolean
    horses: any
    dogs: any
    people: Person[]
  }
  paymentTerm: string
}

export const AdditionalCard: React.FC<Props> = (props) => {
  const additional = props.additional.dogs || props.additional.horses || props.additional.people || props.additional.pool

  return (
    <IonCard>
      <IonCardHeader>
        {props.onEdit && (
          <IonButton
            style={{
              position: 'absolute',
              zIndex: 10,
              right: 10,
              top: 10,
            }}
            onClick={props.onEdit}
            fill={'clear'}
          >
            <IonIcon slot="icon-only" icon={createOutline} />
          </IonButton>
        )}
        <IonCardTitle>Zusätze</IonCardTitle>
      </IonCardHeader>

      {props.additional.pool && <IonItem>
        <IonLabel position="floating">Pool</IonLabel>
        <IonInput value={'Ja'} readonly />
      </IonItem>}

      {props.additional.horses > 0 && <IonItem>
        <IonLabel position="floating">Pferde</IonLabel>
        <IonInput value={props.additional.horses} readonly />
      </IonItem>}

      {props.additional.dogs > 0 && <IonItem>
        <IonLabel position="floating">Hunde</IonLabel>
        <IonInput value={props.additional.dogs} readonly />
      </IonItem>}

      {props.additional.people && props.additional.people.map(p => (
        <IonItem key={p.id}>
          <IonLabel position="floating">Mitversicherte Person</IonLabel>
          <IonInput value={`${p.gender === 'm' ? 'Herr' : 'Frau'} ${p.firstName} ${p.lastName}, ${moment(p.birthday).format('YYYY-MM-DD')}`} readonly />
        </IonItem>
      ))}

      <IonItem>
        <IonLabel position="floating">Zahlweise / Abbuchung</IonLabel>
        <IonInput value={props.paymentTerm === 'monthly' ? 'Monatlich' : 'Jährlich'} readonly />
      </IonItem>
    </IonCard>
  )
}
